<template>
    <div class="selection-script" v-if="!showInfo">
        <div class="list-selection" id="ListSelection">
            <div class="selection-item"
                v-for="option in options"
                v-bind:key="option.id"
				v-bind:style="{
					width: itemWidth + 'px'
				}"
            >
				<div class="editor-item" v-if="quiz.mode == 'editor'">
                    <div class="image"
                        v-bind:style="{
                            width: itemWidth + 'px',
                            height: itemWidth + 'px'
                        }"
                    >
                        <img v-if="option.media && option.media.type == 'image'"
                            v-bind:src="option.media.value.src"
                        />
                        <div class="btn-icon">
                            <div class="edit-img-icon" @click="selectMedia(quiz.questions.id, option.id, quiz)">
                                <EditImageIcon />
                            </div>
                            <div class="trash-icon" @click="removeOption(quiz.questions.id, option.id, quiz)">
                                <TrashIcon />
                            </div>
                        </div>
                    </div>
                    <div 
                        class="change-title"
                        v-if="changeOptions.check && changeOptions.value == option.id" 
                        v-bind:style="{
                        width: itemWidth + 'px'
                    }">
                        <input :value="option.text" @input="changeOption(option.id, $event, quiz)" @change="changeOption(option.id, $event, quiz)" :ref='"edit_text_" + option.id' @focusout="setChangeTitle" />
                    </div>
                    <div class="title" @click="changeTile(option)" v-else>{{ option.text }}</div>
                </div>
                <div class="item" v-else v-on:click="selectOption(option)">
                    <div class="image"
                        v-bind:style="{
                            width: itemWidth + 'px',
                            height: itemWidth + 'px'
                        }"
                    >
                        <img v-if="option.media && option.media.type == 'image'"
                            v-bind:src="option.media.value.src"
                        />
                    </div>
                    <p class="title">{{ option.text }}</p>
                </div>
            </div>

            <div class="add-option"
				v-if="quiz.mode == 'editor'"
                @click="addOption(quiz)"
				v-bind:style="{
					width: itemWidth + 'px',
                    height: itemWidth + 'px'
				}"
            >
                <AddIcon />
            </div>
        </div>
    </div>

    <div class="selection-script" v-else>
        <div class="content-selection">

        <div class="info">
            <p class="title">{{optionSelected.text}}</p>
            <p class="content" v-html="optionSelected.description" />
        </div>

        <div class="share-fb"
			v-if="quiz.settings.script.allowShareFacebook"
			@click="shareFb(optionSelected)"
		>
            <FacebookIcon />
            <span class="txt-share">Chia sẻ lên Facebook</span>
        </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import FacebookIcon from '@/ui/icons/svgs/icons/FacebookIcon'
import EditImageIcon from '../ui/icons/svgs/icons/EditImageIcon'
import TrashIcon from '@/ui/icons/svgs/icons/TrashIcon'
import AddIcon from '@/ui/icons/svgs/icons/AddIcon'
import calculateSize from '@/common/calculate-size';
import ResizeObserverPolyfill from 'resize-observer-polyfill';

export default {
    name: 'Main',
    data() {
        return {
            showInfo: false,
			optionSelected: null,
            itemWidth: 0,
            changeOptions: {
                check: false,
                value: ''
            }
        }
    },
    components: {
        FacebookIcon,
        EditImageIcon,
        TrashIcon,
        AddIcon
    },
    computed: {
        quiz() {
            return this.$store.getters.quiz || [];
		},
		options() {
			return this.quiz.questions.options || [];
		}
    },
    methods: {
        selectOption(option) {
            this.showInfo = true;
            this.optionSelected = option;
            this.quiz.playComplate();
        },
        shareFb(data) {
            // remove html in description
            const des = data.description.replace(/<[^>]*>?/gm, '');
            
            this.quiz.action("share", "facebook", {
                title: data.text,
                image: ((data.media || {}).value || {}).src,
                description: des,
                quote: data.text + " - " + des,
                url: this.quiz.scriptOptions.linkShare
            });
        },
        removeOption(question_id,option_id,quiz){
            quiz.action('removeOption', question_id, option_id);
        },
        selectMedia(question_id,option_id,quiz){
            quiz.action('selectOptionMedia', question_id, option_id)
        },
        addOption(quiz){
            quiz.action('addOption', quiz.questions.id);
        },
        changeTile(option){
            this.changeOptions.check = true
            this.changeOptions.value = option.id
            this.$nextTick(function () {
                this.$refs["edit_text_" + option.id][0].focus()
            })
        },
        changeOption(option_id, $event, quiz){
            quiz.action('changeOption', quiz.questions.id, option_id, 'text', $event.target.value)
        },
        setChangeTitle(){
            this.changeOptions.check = false
            this.changeOptions.value = ''
        }
	},
	mounted() {
		const calSize = () => {
			const size = calculateSize('#ListSelection', 150);

			this.itemWidth = size.width - (15 / size.col) - 15;
		};
		const resizeObserver = new ResizeObserverPolyfill(() => {
			calSize();
		});
		resizeObserver.observe(document.querySelector('#ListSelection'));
	}
}
</script>

<style lang="scss">
  @import '~@/styles/selection.scss';
</style>